import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { transitions } from 'polished';

const FormContainer = styled.div`
  label {
    display: block;
    color: ${props => props.theme.colors.white};
    font-size: 0.8em;
    font-weight: 600;
  }

  input,
  select,
  textarea {
    font-size: 0.9em;
    font-family: ${props => props.theme.fonts.sofiapro};
    background: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.merciless};
    padding: 0.8em;
    width: 100%;
    border: 0;
    margin-bottom: 1em;
  }

  textarea {
    resize: vertical;
  }

  input[type='submit'] {
    display: inline-block;
    background: linear-gradient(
      to right,
      #92fcf4 50%,
      ${props => props.theme.colors.boogaloo} 50%
    );
    background-size: 200% 100%;
    background-position: right bottom;
    border-radius: 3px;
    width: auto;
    font-weight: 700;
    padding: 1rem 3rem;
    margin-top: 1em;
    cursor: pointer;
    ${props =>
      transitions(
        ['color', 'background', 'transform'],
        props.theme.animations.smoothTransitionBezier
      )}

    &:hover {
      background-position: left bottom;
    }
  }

  .submitted-message,
  .legal-consent-container {
    color: ${props => props.theme.colors.white};

    a {
      color: ${props => props.theme.colors.white};
    }
  }

  .legal-consent-container {
    font-size: 0.8em;
  }

  .hs-error-msgs {
    margin: -0.8em 0 1em;
    padding: 0;
    list-style: none;

    label {
      color: ${props => props.theme.colors.drizzleberry};
    }
  }
`;

const HubspotForm = ({ formId, portalId, id, ...props }) => {
  /**
   * Custom-load the external form script so we can track when it loads or fails
   * and make any customizations needed when it does
   */
  useEffect(() => {
    if (window.hbspt && portalId && formId && id) {
      window.hbspt.forms.create({
        portalId: portalId,
        formId: formId,
        target: `#${id}`,
        ...props,
      });
    }
  }, [formId, id, portalId, props]);

  return <FormContainer id={id} className="hubspot-container"></FormContainer>;
};

export default HubspotForm;
